import { Box, Collapse, Flex, Text, useDisclosure } from "@chakra-ui/react"
import { formatTime } from "./formatTime"

export function ResultRow({
  result,
  position,
  rowKey,
  rowRefs,
  showResults
}: any) {

  const { isOpen, onToggle } = useDisclosure()

  return (
    <Box
      ref={(el) => (rowRefs.current[rowKey] = el)}
      borderTopWidth="1px"
    >
      <Flex
        p={2}
        cursor="pointer"
        align="center"
        onClick={onToggle}
        _hover={{ bg: "gray.50" }}
      >
        <Text w="50px">{position}</Text>

        <Text flex="1" whiteSpace="normal" textAlign="left">
          {result.firstname} {result.lastname}
        </Text>

        {showResults && <Text fontFamily="mono">
          {result.startTime == null 
          ? "-" // DNS
          : result.finishTime == null 
          ? "-" // DNF
          : formatTime(result.finishTime - result.startTime)}
        </Text>}
      </Flex>

      <Collapse in={isOpen}>
        <Box pl={12} pb={3} fontSize="sm" color="gray.600">
          <Text>
            <b>Namn:</b> {result.firstname} {result.lastname}
          </Text>

          <Text>
            <b>Nr:</b> {result.startnumber}
          </Text>

          <Text>
            <b>År:</b> {result.birthYear}
          </Text>

          <Text>
            <b>Tid: </b> 
          {result.startTime == null 
          ? "-" // DNS
          : result.finishTime == null 
          ? "-" // DNF
          : formatTime(result.finishTime - result.startTime)}
          </Text>

          <Text>
            <b>Placering:</b> {position}
          </Text>

          <Text>
            <b>Klubb/Lag:</b> {result.clubOrTeam || "-"}
          </Text>

        </Box>
      </Collapse>
    </Box>
  )
}